import { Injectable } from '@angular/core';
import Base64 from 'crypto-js/enc-base64';
import Base64url from 'crypto-js/enc-base64url';
import Utf8 from 'crypto-js/enc-utf8';
import SHA256 from 'crypto-js/sha256';
import cryptoRandomString from 'crypto-random-string';
import { CryptoRandomString } from '../../enums/crypto-random-string';

@Injectable({
  providedIn: 'root',
})
export class OktaTokenService {
  generateRandomString(length: number, type?: CryptoRandomString): string {
    return Boolean(type) ? cryptoRandomString({ length, type }) : cryptoRandomString({ length });
  }

  generateBase64URL(string: string): string {
    return Base64.stringify(Utf8.parse(string)).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  }

  generateCodeChallenge(code_verifier: string): string {
    return Base64url.stringify(SHA256(code_verifier));
  }
}
